import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAppMeta } from "hooks";
import { useGetShipmentRefundDetailQuery, useUpdateShipmentRefundMutation } from "store/services/PaymentsApi/shipmentRefundApi";
import ShipmentRefundForm from "./ShipmentRefundComponents/ShipmentRefundForm";


const ShipmentRefundEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Shipment Refunds", path: "/app/crm/shipment-refund/list" },
    { title: "Edit Refund" },
  ];

  const {
    data: shipmentRefundDetail,
    isLoading: loadingShipmentRefund,
    error,
  } = useGetShipmentRefundDetailQuery(id);

  const [updateShipmentRefund, { isLoading: updatingShipmentRefund }] =
    useUpdateShipmentRefundMutation();

  const handleUpdateShipmentRefund = async (data) => {
    const payload = { _id: id, ...data };

    try {
      await updateShipmentRefund(payload).unwrap();
      toast.success("Shipment Refund successfully updated!");
      navigate(`/app/crm/shipment-refund/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Shipment Refund!"
      );
    }
  };

  useAppMeta("Edit Shipment Refund");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingShipmentRefund || updatingShipmentRefund}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <ShipmentRefundForm
          isBusy={loadingShipmentRefund || updatingShipmentRefund}
          shipmentRefundDetail={shipmentRefundDetail}
          onSubmit={handleUpdateShipmentRefund}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ShipmentRefundEditScreen;